import { useEffect, useState } from "react";
import api from "../../lib/api";

// Temporary Production guard: the backend decides; offline Preview devices reuse the last answer.
const KEY = "hoshizora_pos_enabled";
let cached = null;

export function usePosEnabled() {
    const ls = localStorage.getItem(KEY);
    const [on, setOn] = useState(cached ?? (ls === null ? null : ls === "1"));
    useEffect(() => {
        api.get("/pos/enabled", { timeout: 8000 }).then(({ data }) => {
            cached = !!data.enabled;
            localStorage.setItem(KEY, cached ? "1" : "0");
            setOn(cached);
        }).catch((e) => {
            if (e.response) { cached = false; localStorage.setItem(KEY, "0"); setOn(false); }
        });
    }, []);
    return on;
}

export default function PosGate({ children }) {
    const on = usePosEnabled();
    if (on === null) return <p className="text-sm text-neutral-400">Loading…</p>;
    if (!on) return <p className="text-sm text-neutral-500" data-testid="pos-unavailable">This page is not available.</p>;
    return children;
}
